$(".nav__searchIcon").on("click", function () {
  $(".searchDrop").animate({ width: "toggle" }, 350),
    $(".searchDrop input[type='search']").focus(),
    $("body").toggleClass("td-search--open");
}),
  $(".td-search__overlay").on("click", function () {
    $(".searchDrop").animate({ width: "toggle" }, 350),
      $("body").toggleClass("td-search--open");
  }),
  jQuery(".burgerMenu").on("click", function () {
    jQuery(".navMob").addClass("navMob--open"),
      jQuery(".navMob__backdrop").fadeIn(),
      jQuery("html").addClass("noScroll"),
      $("body").hasClass("td-search--open") &&
        ($(".searchDrop").animate({ width: "toggle" }, 0),
        $("body").removeClass("td-search--open"));
  }),
  jQuery("[slidebutton]").on("click", function () {
    var e = jQuery(this).attr("slidebutton");
    jQuery("[slidecontainer]").hide(),
      jQuery('[slidecontainer="' + e + '"]').show(),
      jQuery(".navMob__sled").attr("style", "left:-100%;");
  }),
  jQuery(".navMob__backBtn").on("click", function () {
    jQuery("[slidecontainer]").hide(),
      jQuery(".navMob__sled").attr("style", "left:0%;");
  }),
  jQuery(".navMob__backdrop, .closeBtn").on("click", function () {
    jQuery(".navMob").removeClass("navMob--open"),
      jQuery(".navMob__backdrop").fadeOut(),
      jQuery(".navMob--opacityn").css({ opacity: "1" }),
      jQuery(".navMob--opacity").css({ opacity: "1" }),
      jQuery("html").removeClass("noScroll");
  }),
  (window.onclick = function (e) {
    if (!e.target.matches(".nav__dropbtn")) {
      var s,
        a = document.getElementsByClassName("nav__dropdown-content");
      for (s = 0; s < a.length; s++) {
        var t = a[s];
        t.classList.contains("nav__dropdown-content--show") &&
          t.classList.remove("nav__dropdown-content--show");
      }
    }
  });
var i,
  coll = document.getElementsByClassName("navMob__collapsible navMob__link");
for (i = 0; i < coll.length; i++)
  coll[i].addEventListener("click", function () {
    this.classList.toggle("navMob__active");
    var e = this.nextElementSibling;
    e.style.maxHeight
      ? (e.style.maxHeight = null)
      : (e.style.maxHeight = e.scrollHeight + "px");
  });
if (!customElements.get("search-bar")) {
  class e extends HTMLElement {
    constructor() {
      super(),
        (this.search = {
          ongoingRequest: null,
          ongoingTimeoutId: -1,
          throttleMs: 500,
          searchUrlKey: "searchUrl",
          resultsSelector: ".search-bar__results",
          resultsLoadingClass: "search-bar--loading-results",
          resultsLoadedClass: "search-bar--has-results",
          loadingMessage: theme.strings.searchLoading,
          moreResultsMessage: theme.strings.searchMoreResults,
          emptyMessage: theme.strings.searchNoResults,
        });
    }
    connectedCallback() {
      $('.search-bar[data-live-search="true"]', this.$container).length &&
        $(this.$container).on(
          "keyup" + this.namespace + " change" + this.namespace,
          '.search-bar[data-live-search="true"] input[name="q"]',
          this.functions.updateSearchResults.bind(this)
        );
    }
  }
  customElements.define("search-bar", e);
}





var swiperThumbs = new Swiper(".mySwiper", {
    direction: "vertical",
    spaceBetween: 10,
    slidesPerView: "auto", 
    centeredSlides: false,
    freeMode: {
        enabled: true, 
        momentum: true, 
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true, 
    mousewheel: {
        releaseOnEdges: true,
        sensitivity: 1, 
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    on: {
        slideChange: function () {
            updateNavigation();
        },
        transitionEnd: function () {
            updateNavigation();
        }
    }
});

var swiperMain = new Swiper(".mySwiper2", {
    effect: "fade",
    fadeEffect: {
        crossFade: true,
    },
    thumbs: {
        swiper: swiperThumbs, 
    },
    watchOverflow: true, 
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    on: {
        slideChange: function () {
          updateNavigation();
          autoPlayVideo(swiperThumbs,swiperMain);
        },
        transitionEnd: function () {
            updateNavigation();
        }
    }
});

// Function to manually control navigation buttons
function updateNavigation() {
    setTimeout(() => {
        const nextBtn = document.querySelector(".swiper-button-next");
        const prevBtn = document.querySelector(".swiper-button-prev");

        if (swiperMain.isEnd) {
            nextBtn.classList.add("swiper-button-disabled");
            nextBtn.setAttribute("disabled", true);
        } else {
            nextBtn.classList.remove("swiper-button-disabled");
            nextBtn.removeAttribute("disabled");
        }

        if (swiperMain.isBeginning) {
            prevBtn.classList.add("swiper-button-disabled");
            prevBtn.setAttribute("disabled", true);
        } else {
            prevBtn.classList.remove("swiper-button-disabled");
            prevBtn.removeAttribute("disabled");
        }
    }, 100);
}

// Ensure the navigation buttons update after everything loads
setTimeout(() => {
    swiperThumbs.update();
    swiperMain.update();
    updateNavigation();
}, 500);

function autoPlayVideo(thumbSwiper,mainswiper){

let getVideoButton= document.querySelector('[id^="Deferred-Poster-"]');
    let activeSlide = thumbSwiper.wrapperEl.querySelector(".swiper-slide-thumb-active .product-single__media");
  let activeSlideMain = mainswiper.wrapperEl.querySelector(".swiper-slide-active .product-single__media");
  if(activeSlide || activeSlideMain){
    let videoAttribute = activeSlide ? activeSlide.getAttribute("data-media") : activeSlideMain.getAttribute("data-media"); 
        if (videoAttribute.includes("media-video")) {
            const deferredMedia = document.querySelector("deferred-media");
            if (deferredMedia) {
                deferredMedia.loadContent();
           }
        }
}
}





